export { default } from './footer.component';